"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const winston_1 = require("winston");
const vars_1 = __importDefault(require("./config/vars"));
const TecmaTransport_1 = __importDefault(require("./transports/TecmaTransport"));
/**
 * Create and configure a basic Winston logger that propagates errors to a specific endpoint
 *
 * Options that can be set using specific environment variables:
 *  - REACT_APP_ERROR_API_ENDPOINT : specifies the endpoint used to propagate errors to
 *  - REACT_APP_WINSTON_LOG_LEVEL : specifies the minimum level logged by Winston
 */
const logger = (0, winston_1.createLogger)({
    level: vars_1.default.winston.logLevel,
    format: winston_1.format.combine(winston_1.format.colorize(), winston_1.format.simple()),
    transports: [
        new winston_1.transports.Console(),
        new TecmaTransport_1.default({ level: 'error' }),
    ],
});
exports.default = logger;
